module.exports = __webpack_public_path__ + "img/3.a0ed68eb.png";